import { Currency } from '../types/api/Currency/Currency';
import Enums from '../types/api/Enums';

type CalculateWithDeliveryTotalPriceParams = {
  unitPrice: Currency;
  haulRate: Currency;
  taxRate: number;
  haulTaxable: boolean;
};

/**
 * Calculates the total price for an aggregate product based on
 * the unit price, haul rate and tax rate.
 */
export const CalculateWithDeliveryTotalPrice = ({
  unitPrice,
  haulRate,
  taxRate,
  haulTaxable,
}: CalculateWithDeliveryTotalPriceParams): Currency | null => {
  const priceAfterTax = unitPrice.multiply(1 + taxRate) ?? Currency.zero();
  const haulTaxRate = haulTaxable ? taxRate : 0;
  const rateAfterTax = haulRate.multiply(1 + haulTaxRate) ?? Currency.zero();

  return priceAfterTax.add(rateAfterTax);
};

export const WithDeliveryProductCategory = (category: Enums.ProductCategory): boolean =>
  [Enums.ProductCategory.Asphalt, Enums.ProductCategory.Aggregate].includes(category);

type PlantWithDeliveryProducts = {
  products?: Array<{
    product?: { category?: Enums.ProductCategory | null } | null;
    deliveryType?: unknown;
  }> | null;
};

export const ProductDeliveryTypeIsValid = (
  plants: PlantWithDeliveryProducts[] | undefined | null,
): boolean =>
  (plants ?? []).every((plant) =>
    (plant.products ?? []).every((p) => {
      const category = p.product?.category;
      return !(category && WithDeliveryProductCategory(category) && p.deliveryType == null);
    }),
  );
